module.exports = __webpack_public_path__ + "img/maritzburg-united-logo-icon.3bd8e80b.png";